<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>To Kill a Tsar</h1>
<p class="author"><span class="size">by</span> G.K. George</p>
<p class="author1">ILLUSTRATIONS by</p>
<p class="author2">George O. Linabury</p>
<div class="img_container1">
<img alt="image" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?27f098af